import { render, staticRenderFns } from "./notifyEnterpriseSubmitMaterial.vue?vue&type=template&id=1a5da07b&scoped=true&"
import script from "./notifyEnterpriseSubmitMaterial.vue?vue&type=script&lang=js&"
export * from "./notifyEnterpriseSubmitMaterial.vue?vue&type=script&lang=js&"
import style0 from "./notifyEnterpriseSubmitMaterial.vue?vue&type=style&index=0&id=1a5da07b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5da07b",
  null
  
)

export default component.exports